/** @jsx React.createElement */
import React, { Component } from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { ASSET_VERSION_QUERY } from '../../utils/assetVersionQuery';
import { _mapStateToProps } from "./AbstractWelcomePage";
class Help145 extends Component {
    wrapperRef;
    constructor(props) {
        super(props);
        this.state = {
            displayMenu: false
        };
        this.wrapperRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }
    handleClickOutside = (event) => {
        if (this.state.displayMenu &&
            this.wrapperRef.current &&
            !this.wrapperRef.current.contains(event.target)) {
            this.setState({ displayMenu: false });
        }
    };
    toggleDropdown = (e) => {
        e.stopPropagation();
        this.setState((prev) => ({
            displayMenu: !prev.displayMenu
        }));
    };
    render() {
        const t = this.props.t;
        const title = t('VianovaWelcomePage.help.textTitle');
        const help145Text = t('VianovaWelcomePage.help.text145');
        const helpRispondiamoIn3Squilli = t('VianovaWelcomePage.help.textRispondiamoIn3Squilli');
        const help145Description = t('VianovaWelcomePage.help.text145Description');
        return (React.createElement("div", { className: "help145-wrapper", ref: this.wrapperRef },
            React.createElement("div", { className: "help145-trigger", onClick: this.toggleDropdown },
                React.createElement("div", { className: "testo-help-145" },
                    React.createElement("p", null, title)),
                React.createElement("img", { className: "image-help-145", src: `images/help-145.svg${ASSET_VERSION_QUERY}` })),
            this.state.displayMenu && (React.createElement("div", { className: "dropdown-help145" },
                React.createElement("h6", null,
                    help145Text,
                    " ",
                    React.createElement("br", null),
                    helpRispondiamoIn3Squilli),
                React.createElement("p", null, help145Description)))));
    }
}
export default translate(connect(_mapStateToProps)(Help145));
